/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import update from 'immutability-helper';

import { BaseAppReduxActions } from './Action';

export const DefaultTheme: AppTheme = {
    primary: '#222754',
    primaryContrast: '#ffffff',
    textPrimary: '#2b2f3d',
    secondary: '#01224b',
    secondaryContrast: '#ffffff',
    file: '/images/brand/logo-uow.png',
};

export const baseAppState: BaseApplicationState = {
    menuList: [],
    theme: DefaultTheme,
    fetchingTemplate: false,
    sidebarOptions: {
        dashboard: {
            searchBy: '',
            sortBy: 'oldestToNew',
            initializeFromRedux: false,
            initializeFromLogin: false,
            initializeFromReload: false,
            resetInitialize: false,
            rowsPerPage: 10,
            reduxInitValues: {
                binNumber: '',
                clientName: '',
                cm9Number: '',
                completedDate: '',
                limit: '',
                loanNumber: '',
                offset: '',
                operatorId: '',
                packetStatus: [],
                packetType: [],
                slaDaysLeft: 0,
                sort: '',
                uploadAge: 0,
                uploadDate: '',
            },
            packetStatus: [],
            packetType: [],
            textField: '',
        },
        managePacket: {
            searchBy: '',
            sortBy: 'oldestToNew',
            initializeFromLogin: false,
            initializeFromReload: false,
            initializeFromRedux: false,
            resetInitialize: false,
            reduxInitValues: {},
            rowsPerPage: 10,
            packetStatus: [],
            packetType: [],
            textField: '',
        },
    },
};

export const updateCSSThemeVariables = (theme: AppTheme): void => {
    const app: any = document.querySelector(':root');
    app.style.setProperty('--primary', theme.primary);
    app.style.setProperty('--primary-contrast', theme.primaryContrast);
    app.style.setProperty('--side-bar-bg', theme.primary);
    app.style.setProperty('--side-bar-text', theme.primaryContrast);
    app.style.setProperty('--text-primary', theme.textPrimary);
    app.style.setProperty('--btn-primary-background-color', theme.primary);
    app.style.setProperty('--btn-primary-text-color', theme.primaryContrast);
    app.style.setProperty('--btn-secondary-text-color', theme.textPrimary);
};

const BaseAppStateReducer = (
    state = baseAppState,
    action: any = { type: '', payload: {} }
): BaseApplicationState => {
    switch (action.type) {
        case BaseAppReduxActions.BASE_APP_MENU_LIST:
            return update(state, {
                $merge: {
                    menuList: action.payload,
                },
            });
        case BaseAppReduxActions.BASE_APP_SET_FETCH_TEMPLATE:
            return update(state, {
                $merge: {
                    fetchingTemplate: action.payload,
                },
            });
        case BaseAppReduxActions.BASE_APP_SET_SIDEBAR_DASHBOARD_THEME:
            return update(state, {
                $merge: {
                    sidebarOptions: {
                        managePacket: state.sidebarOptions.managePacket,
                        dashboard: {
                            ...state.sidebarOptions.dashboard,
                            ...action.payload,
                        },
                    },
                },
            });
        case BaseAppReduxActions.BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_RESET:
            return update(state, {
                $merge: {
                    sidebarOptions: {
                        managePacket: state.sidebarOptions.managePacket,
                        dashboard: {
                            ...state.sidebarOptions.dashboard,
                            resetInitialize: action.payload,
                        },
                    },
                },
            });
        case BaseAppReduxActions.BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_LOGIN:
            return update(state, {
                $merge: {
                    sidebarOptions: {
                        managePacket: state.sidebarOptions.managePacket,
                        dashboard: {
                            ...state.sidebarOptions.dashboard,
                            initializeFromLogin: action.payload,
                            initializeFromReload: action.payload,
                        },
                    },
                },
            });
        case BaseAppReduxActions.BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_FROM_INTERCEPTOR:
            return update(state, {
                $merge: {
                    sidebarOptions: {
                        managePacket: state.sidebarOptions.managePacket,
                        dashboard: {
                            ...state.sidebarOptions.dashboard,
                            reduxInitValues: action.payload,
                            initializeFromRedux: true,
                            resetInitialize: false,
                        },
                    },
                },
            });
        case BaseAppReduxActions.BASE_APP_SET_SIDEBAR_PACKET_THEME:
            return update(state, {
                $merge: {
                    sidebarOptions: {
                        managePacket: {
                            ...state.sidebarOptions.managePacket,
                            ...action.payload,
                        },
                        dashboard: state.sidebarOptions.dashboard,
                    },
                },
            });

        case BaseAppReduxActions.BASE_APP_SET_THEME:
            updateCSSThemeVariables(action.payload);
            return update(state, {
                $merge: {
                    theme: action.payload,
                },
            });
        case BaseAppReduxActions.BASE_APP_SET_DEFAULT_THEME:
            updateCSSThemeVariables(DefaultTheme);
            return update(state, {
                $merge: {
                    theme: DefaultTheme,
                },
            });
        case BaseAppReduxActions.BASE_APP_SET_CSS_THEME:
            updateCSSThemeVariables(action.payload);
            return state;
        default:
            return state;
    }
};

export default BaseAppStateReducer;
